/*
 *  Copyright (c) 2020 Cognitran Limited. All Rights Reserved.
 */

/* Inline copy of context.js. Tried to include the file but causes failure due to https://github.com/wiledal/gulp-include/issues/97 */
itis = window.itis || {};
isis = itis;
$i = itis;

/**
 * I18n.
 */
if ($i.i18n === undefined) {
    $i.i18n = {
        messages: {}
    };

    $i.i18n.format = function (message, arguments) {
        var str = message;
        for (var i = 0; i < arguments.length; i++) {
            var reg = new RegExp("\\{" + i + "\\}", "gm");
            str = str.replace(reg, arguments[i]);
        }
        return str;
    }

    $i.i18n.get = function (key) {
        if (arguments.length > 1) {
            var args = Array.prototype.slice.call(arguments, 1);
            return $i.i18n.format($i.i18n.messages[key], args);
        } else {
            return $i.i18n.messages[key];
        }
    };

    $i.i18n.put = function (key, message) {
        $i.i18n.messages[key] = message;
    };
}
/* END inline copy of context.js */

$('html').removeClass('no-js').addClass('js');

/** Add endsWith if not supported. */
if (typeof String.prototype.endsWith !== 'function') {
    String.prototype.endsWith = function(suffix) {
        return this.indexOf(suffix, this.length - suffix.length) !== -1;
    };
}

$i.addActionError = function (error) {
    var actionErrors = $('<div class="action-errors"></div>'),
        actionErrorsList = $('<ul class="action-error-list errorMessage"></ul>'),
        existing;

    // See if the action-error-list exists already.
    existing = $('.action-error-list');
    if (!existing.length)
    {
        // Find the title and insert after.
        $('h2', '.content-area').first().after(actionErrors);
        actionErrorsList.appendTo(actionErrors);
    }
    else
    {
        actionErrorsList = existing;
    }

    actionErrorsList.append("<li><span class=\"action-error\">" + error + "</span></li>");
};

/**
 * Selectize.
 */
$(function() {
    var $selectizes = $('select.selectize, select[data-selectize]');

    $selectizes.each(function(i, element) {
        var $selectize = $(element),
            query = $selectize.data('selectize-query-key') || 'query',
            queryLimiter = $selectize.data('selectize-query-limiter') || 0,
            queryObj = {},
            url = $selectize.data('selectize-url'),
            config = {
                plugins: ['remove_button'],
                dropdownParent: 'body',
                valueField: 'value',
                labelField: 'label',
                searchField: 'label'
            };

        queryObj[query] = null;

        if (url) {
            config.load = function(result, callback) {
                if (result.length <= queryLimiter) return callback();
                queryObj[query] = result;

                $.ajax({
                    url: url,
                    data: queryObj,
                    type: 'GET',
                    dataType: "json",
                    error: function() {
                        callback();
                    },
                    success: function(res) {
                        var cache = [];

                        // if the value field is the object key itself we specify a data attribute to resolve this
                        if (typeof $selectize.data('selectize-value-key') !== 'undefined') {
                            if (!Array.isArray(res)) {
                                $.each(res, function(key, obj) {
                                    cache.push($.extend(obj, { key: key }));
                                });
                            } else {
                                cache = res.slice();
                                $.each(cache, function(key, obj) {
                                    obj.key = key;
                                });
                            }

                            res = [];

                            $.each(cache, function(key, obj) {
                                res.push({
                                    label: obj.label,
                                    value: obj.key
                                });
                            });
                        }

                        callback(res);
                    }
                });
            }
        }

        $selectize.selectize(config);
    });
});

/**
 * Equal heights.
 */
(function($) {
    $.fn.equalHeights = function(minHeight, maxHeight) {
        tallest = (minHeight) ? minHeight : 0;
        this.each(function() {
            if($(this).height() > tallest) {
                tallest = $(this).height();
            }
        });
        if((maxHeight) && tallest > maxHeight) tallest = maxHeight;
        return this.each(function() {
            $(this).height(tallest).css("overflow","auto");
        });
    };
})(jQuery);

/**
 * Basic utility functions.
 */
(function($i, $, undefined){
    $i.isEmpty = function(e) {
        return e === null ||
               e === undefined ||
               e === '' ||
               e === [] ||
               (typeof e === 'object' && $.isEmptyObject(e));
    };
    $i.isString = function(e) { return typeof e === 'string'; };
    $i.isArray = $.isArray;
    $i.isObject = function(e) { return typeof e === 'object'; };
    $i.isFunction = function(e) { return typeof e === 'function'; };
    $i.stopPropagation = function(event) { event.stopPropagation(); };
    $i.preventDefault = function(event) { event.preventDefault(); };
    $i.isIe = function () { return (/MSIE/i).test(navigator.userAgent) || (/Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/).test(navigator.userAgent) || (/Edge/i).test(navigator.userAgent); };
    $i.maxWidthMobile = 767; // in pixels
    $i.maxWidthTablet = 980; // in pixels
})(isis, jQuery);

(function ($i) {
    $i.currentProcedureInfo = {
      sourceId: '',
      nodeId: ''
    };
})(isis);

/**
 * Override the default loading text for the bootstrap button 'loading' state
 *
 * See http://getbootstrap.com/2.3.2/javascript.html#buttons, http://jsfiddle.net/PHmdT/.
 */
$.extend($.fn.button.defaults, { loadingText: isis.i18n.get('main.help.loading') });

$.fn.findNext = function (selector, scope, steps) {
    var next, kids, currentElement, rs, id;

    // Steps given? Then parse to int
    if (steps) {
        steps = Math.floor(steps);
    }
    else if (steps === 0) {
        // Stupid case :)
        return this;
    }
    else {
        // Else, try the easy way
        next = this.next(selector);
        if (next.length)
            return next;
        // Easy way failed, try the hard way :)
        steps = 1;
    }

    // Set scope to document or user-defined
    scope = (scope) ? $(scope) : $(document);

    // Find kids that match selector: used as exclusion filter
    kids = this.find(selector);

    // Find in parent(s)
    currentElement = $(this);
    while (currentElement.length > 0 && currentElement[0] != scope[0]) {
        // Move up one level
        currentElement = currentElement.parent();
        // Select all kids of parent
        //  - excluding kids of current element (next != inside),
        //  - add current element (will be added in document order)
        rs = currentElement.find(selector).not(kids).add($(this));
        // Move the desired number of steps
        id = rs.index(this) + steps;
        // Result found? then return
        if (id > -1 && id < rs.length)
            return $(rs[id]);
    }
    // Return empty result
    return $([]);
};

/**
 * Loading button.
 */
$.fn.loadingButton = function (options) {
    var $btn = $(this),
        defaults = {
            // Delay in millis before resetting the button automatically.
            'delay': null,
            // Whether to show a spinner on the button.
            'spinner': true,
            // The method being called.
            'method': 'init',
            // The HTML for the spinner.
            'spinnerHtml': '<i class="icon icon-spinner icon-spin" aria-hidden="true"></i> ',
            // The HTML for the button.
            'buttonHtml': '<button type="button" class="loading-button"></button>'
        };

    function loading() {
        var  oWidth = $btn.width(),
             oHeight = $btn.height(),
             $loadingButton = $(options.buttonHtml);

        // Hide the original button and add the new button as 'data' for later use.
        $btn.hide().data('loadingButton', $loadingButton);

        // Copy classes from original button to new button.
        $loadingButton.attr('class', $loadingButton.attr('class') + ' ' + $btn.attr('class'));

        // Set the bootstrap loading state on the button.
        $loadingButton.button('loading');

        // Insert the new button after the original button.
        $loadingButton.insertAfter($btn);

        if (options.spinner) {
            // Prepend the spinner to the button.
            $loadingButton.prepend(options.spinnerHtml);
        }

        _.defer(function() {
            // Fix the width to the original buttons width (we may undo this later).
            $loadingButton.width(oWidth);
            _.defer(function() {
                if ($loadingButton.height() > oHeight) {
                    // If the fixed width of the button makes the text wrap then let the browser resize it.
                    $loadingButton.css('width', '');
                }
            });
        });

        if (typeof options.delay === 'number') {
            _.delay(function() { $btn.loadingButton('reset'); }, options.delay);
        }
    };

    function reset() {
        // Show the original button and remove the loading button.
        $btn.show().data('loadingButton').remove();
    }

    function init() {
        $btn.on('click.loadingButton', function () {
            $(this).loadingButton('loading');
        });
    }

    if (typeof options === 'string') {
        options = { 'method': options };
    }

    options = $.extend({}, defaults, options);

    switch (options.method) {
        case 'reset':
            reset();
            break;
        case 'loading':
            loading();
            break;
        case 'init':
        default:
            init();
    }

    return $btn;
};

$(function() {
    $('button[type="submit"].disable-on-click, input[type="submit"].disable-on-click').loadingButton();
});

/**
 * Vehicle favourite star.
 */
(function($i, $){
    $i.initVehicleFavouriteStar = function (lookupQuery) {
        var container = $('.favourite-container'), star = container.find('.favourite-star'), checked = star.hasClass('favourite-star-checked');
        container.on('click', function(e){
            function set(check) {
                checked = check;
                star.removeClass(checked ? 'favourite-star-unchecked' : 'favourite-star-checked')
                    .addClass(checked ? 'favourite-star-checked' : 'favourite-star-unchecked')
                    .attr('title', checked ? $i.i18n.get('vehicle.summary.unfavourite') : $i.i18n.get('vehicle.summary.favourite'));
            }

            e.preventDefault();
            set(!checked);

            $.ajax({
                type: 'POST',
                url: $i.contextPath + "/service/vehicle/favourite?" + lookupQuery,
                data: {favourite: checked},
                dataType: 'json',
                timeout: 10000,
                success: function(data, textStatus, jqXHR) {
                    if (textStatus === 'success' && $i.isObject(data) && data.hasOwnProperty('success') &&
                        data.success && data.hasOwnProperty('favourite')) {
                        set(data.favourite);
                    }
                },
                complete: function (jqXHR, textStatus) {
                    if (textStatus !== 'success') { set(!checked); }
                }
            });
        });
    };
})(isis, jQuery);


/**
 * Applicability Details.
 */
(function($i, $){
    $i.initialiseApplicabilityDetail = function () {
        var accordions = [];

        $(".containedIn, .hideContainedIn").hide();

        $('.showContainedIn, .hideContainedIn').on('click', function(e) {
            $(this).toggle();
            $(this).siblings().not($('.setting-header')).toggle();
        });

        $('.show-criteria').on('click', function(e) {
            $(this).find('.toggle-option').toggleClass('hide show');
        });

        // Open the only accordion.
        if ($('.dialog-head').length) {
            accordions = $('.dialog-body').find('.accordion-group');
        } else {
            accordions = $('.accordion-group');
        }

        if (accordions.length === 1)
        {
            var accordion = accordions.find('.accordion-body');
            accordion.addClass('in');
            accordions.find('.toggle-option').toggleClass('hide show');
        }

        $('.show-all').on('click', function(e) {
            e.preventDefault();
            var bodies = $('.accordion-body:not(".in")');
            bodies.each(function(idx, ele) {
                $(this).parent().find('.toggle-option').toggleClass('hide show')
            });
            bodies.collapse('show');

        });
        $('.hide-all').on('click', function(e) {
            e.preventDefault();
            var bodies = $('.accordion-body.in');
            bodies.collapse('hide');

            bodies.each(function(idx, ele) {
                $(this).parent().find('.toggle-option').toggleClass('hide show')
            });
        });
    };
})(isis, jQuery);

// Defaults for Flatpickr (datepicker) used across ITIS
var localeCookieRegExp = /LOCALE=([^;]+)/;
var userLocale;
if (!window.userLocale && localeCookieRegExp.test(document.cookie)) {
    // Fallback to cookie value if global variable not set.
    userLocale = localeCookieRegExp.exec(document.cookie)[1];
}
// Fallback to navigator.language if cookie not set.
userLocale = userLocale || navigator.language.replace('-', '_');

$i.getFlatpickrDefaults = function (options) {
    var isUSLocale = userLocale.slice(-2) === 'US';
    var dateTimeFormat = isUSLocale ? 'F j, Y H:i' : 'j F, Y H:i';
    var dateOnlyFormat = isUSLocale ? 'F j, Y' : 'j F, Y';
    return {
        altInput: true,
        altFormat: options.hideTime ? dateOnlyFormat : dateTimeFormat
    };
};

$i.flatpickrCleanButton = function(dateObj, dateStr, instance) {
    var $cal = $(instance.calendarContainer);
    if ($cal.find('.flatpickr-clear').length < 1) {
        $cal.append('<div class="flatpickr-clear btn btn-sm"">' + $i.i18n.get('flatpickr.clear.button') + '</div>');
        $cal.find('.flatpickr-clear').on('click', function() {
            instance.clear();
            instance.close();
        });
    }
}
$i.flatpickrDefaults = $i.getFlatpickrDefaults({ hideTime: false });

(function($){

    /*
     * Select first input field for focus.
     */
    function focusFirstInput()
    {
        var form = $('form:first'), elem, select, textarea;
        // If there is a fragment (hash) in the URL, don't focus the first input as it'll prevent scroll away from the fragment target.
        if(form.length && !window.location.hash && form.attr('id') != 'form-terms')
        {
            $('input:visible', form).each(function(){
                var input = $(this);
                if(!input.hasClass('hasDatepicker') && !input.hasClass('no-focus')){
                    elem = input;
                    return false;
                }
            });
            select = $('select:visible', form).get(0);
            if (select && elem)
            {
                if (select.offsetTop < elem.offsetTop)
                {
                    elem = select;
                }
            }

            textarea = $('textarea:visible', form).get(0);
            if (textarea && elem && textarea.offsetTop < elem.offsetTop)
            {
                elem = textarea;
            }

            if (elem)
            {
                try
                {
                    elem.trigger('focus');
                }
                catch (err)
                {
                    // ignore.
                }
            }
        }
    }

    /*
     * Confirm link.
     */
    (function(){
        $.fn.confirmLink = function(jsOptions) {
            return this.each(function () {
                $(this).off('click.confirm-link').on('click.confirm-link', function(e) {
                    var link = $(this),
                        confirmDelete = link.hasClass('confirm-delete-link'),
                        options = {},
                        title = link.attr('data-confirm-title') || $i.i18n.get(link.attr('data-confirm-title-key')),
                        body  = link.attr('data-confirm-body') || $i.i18n.get(link.attr('data-confirm-body-key')),
                        buttonConfirm = link.attr('data-confirm-button'),
                        buttonCancel = link.attr('data-confirm-cancel'),
                        buttons = {},
                        cancelFunction = function(){
                            if ($i.isFunction(this.options.cancel)) {
                                this.options.cancel.call(this);
                            }
                            this.destroy();
                        },
                        configuration = link.attr('data-confirm-configuration');

                    e.preventDefault();
                    e.stopImmediatePropagation();

                    // Dialog Configuration
                    if (!$i.isString(configuration)) {
                        configuration = confirmDelete ? 'confirm-delete' : 'confirm';
                    }

                    // Title
                    if (!$i.isEmpty(title)) {
                        options.title = title;
                    }

                    // Body
                    if (!$i.isEmpty(body)) {
                        options.body = body;
                    }

                    // Buttons
                    if (!$i.isEmpty(buttonConfirm)) {
                        buttons[buttonConfirm] = { classes: confirmDelete ? 'btn-danger' : 'btn-primary', callback: function() {
                            if ($i.isFunction(this.options.confirm)) {
                                this.options.confirm.call(this);
                            }
                            this.destroy();
                        }};

                        if (!$i.isEmpty(buttonCancel)) {
                            buttons[buttonCancel] = cancelFunction;
                        }
                        else {
                            buttons[$i.i18n.get('button.cancel')] = cancelFunction;
                        }

                        options.buttons = buttons;
                    }

                    options.confirm = function () {
                        link.off('click.confirm-link').addClass('confirmed-link')[0].click();
                        link.confirmLink();
                    };

                    $.extend(options, jsOptions);
                    // Dialog
                    $i.dialog(configuration, options);
                });
            });
        };
    })(); // Confirm link.

    $(function () {
        /*
         * $('.row-fluid, .row').each(function(){ $(this).find('.content-area').equalHeights(); });
         */
        $('.lookup-history-button, .lookup-favourites-button').tooltip();

        focusFirstInput();

        /*
         * Document detail dialog.
         *
         * These links can appear in several areas of the site (e.g. document list, document view, search result, authoring) therefore this
         * is a global hook.
         *
         * Usage:
         *
         * <s:a namespace="/content/document" action="detail" cssClass="document-info-link">
         *     <s:param name="documentId" value="%{documentId}"/>
         *     <i class="icon icon-info-circle"></i>
         * </s:a>
         *
         * or
         *
         * <a href="[contextPath]/content/document/detail?id=[documentId] class="document-info-link">
         *     <i class="icon icon-info-circle"></i>
         * </a>
         */
        (function(){
            var documentIframe = $('iframe.document-content');
            $('.document-info-link').on('click', function(e) {
                var link = $(this);
                e.preventDefault();
                $i.dialog({
                    width: '40%',
                    titleKey: "content.document.detail.title",
                    url: link.attr('href') + ' .detail-data',
                    open: function() {
                        documentIframe.css('visibility', 'hidden');
                        $i.initialiseApplicabilityDetail();
                        this.resize();
                    },
                    close: function() {
                        documentIframe.css('visibility', 'visible');
                        this.box.remove(); //remove dialog box - cause of accordions (multiple object with the same id were created)
                    }
                });
            });
        })();

        // Show the 'Confirm' dialog for links/buttons with either of the 'confirm-link' or 'confirm-delete-link' classes.
        $('a, button, input[type="button"], input[type="submit"]').filter('.confirm-link, .confirm-delete-link').confirmLink();

        // Show the 'Confirm' dialog for the 'Delete' menu item when authoring a document. TODO: Localise.
        $('#delete-document-menu-item').addClass('confirm-delete-link').on('click.confirm-link', function(e) {
            e.preventDefault();
            var href = this.href;
            $i.dialog({
                width: '30%',
                title: 'Are you sure?',
                body: 'Are you sure that you want to delete the document? This action cannot be undone.' +
                    '<br/>' +
                    '<div style="display: flex; align-items: center; gap:10px; margin-top:10px">' +
                    '<input style="margin:0" type="checkbox" id="delete-document-menu-item-checkbox"/>' +
                    '<label style="margin:0" for="delete-document-menu-item-checkbox">Remove documents in other languages that have the same sourceId.</label>' +
                    '</div>',
                buttons: {
                    'Delete': { classes: 'btn-danger', callback: function() {
                            if ($("#delete-document-menu-item-checkbox").is(":checked"))
                            {
                                href += '&deleteOtherLanguages=true';
                            }
                            window.location = href;
                            this.close();
                        }},
                    'Cancel': function() {
                        //clear the id - it will prevent multiple dialogs interfering
                        $("#delete-document-menu-item-checkbox").attr('id', '');
                        this.close();
                    }
                }
            });
        });

        // Show the 'Confirm' dialog for the 'Delete' menu item when authoring a document. TODO: Localise.
        $('#delete-document-group-menu-item').addClass('confirm-delete-link').confirmLink({
            body: 'Are you sure that you want to delete the document group? This action cannot be undone.'
        });

        // Prevent click events on the search options dropdown from closing the pop-up.
        $('#search-options').on('click', $i.stopPropagation);
    });

})(jQuery);

(function($i){

    $i.clearActionErrors = function () {
        $('.action-error-list').remove();
    };

    $i.clearAllActionMessages = function () {
        $('.action-errors, .action-messages').remove();
    };

})(isis);

$(function () {
    $('.document-alternative-language').on('click', function(event) {
      event.preventDefault();
      $(this).parent().next('.document-alternative-translations').toggle();
    });
});

/*
 * Tooltip initialisation via data-toggle="tooltip" attribute.
 */
$(function() {
    $('[data-toggle="tooltip"]').tooltip();
});

/*
 * Fix for issue where bootstrap dropdown menus do not work on mobile devices and popover's do not close when clicked away from.
 */
$(function() {
    $('body').on('touchstart.dropdown', '.dropdown-menu, .dropdown-toggle', function (e) { e.stopPropagation(); });
});

/*
 * Wrap all tables for horizontal scroll, responsiveness
 */
$(function() {
    function enableResponsiveTables() {
        if ($('table').length) {
            $('table').wrap('<div class="responsive-table-wrapper"></div>');
            $('th').addClass('responsive-thead');
        }

        // Add roles to table elements so they can still be identified by screen
        // readers when their display properties are changed by the responsive table CSS.
        $('table.table-responsive').each(function () {
            var table = $(this);
            table.attr('role', 'table');
            table.find('thead, tbody, tfoot').attr('role', 'rowgroup');
            table.find('tr').attr('role', 'row');
            table.find('th').attr('role', 'columnheader');
            table.find('td').attr('role', 'cell');
        });
    };
    enableResponsiveTables();
});

/* Extend footer if fixed mobile menu is present. */
$(function() {
    function extendFooter() {
        var mobileMenu = $('.fixed-mobile-menu');
        var mobileMenuExists = $(mobileMenu).length;
        var mobileMenuIsVisible = $(mobileMenu).is(':visible');

        if (mobileMenuExists && mobileMenuIsVisible) {
            $('.footer').addClass('extend-for-mobile-menu');
        }
        else {
            $('.footer').removeClass('extend-for-mobile-menu');
        }
    }

    extendFooter();

    $(window).on('resize', _.debounce(extendFooter, 250));
});

/* Responsive admin menu toggle in fixed mobile menu. */
$(function() {
    $('.dropup-menu').hide();

    $('.dropup-toggle').on('click', function(e) {
        e.preventDefault();
        $(this).next('.dropup-menu').slideToggle(400);
    });
});

/* Smooth scroll back to top of page. */
$(function() {
    $('.back-to-top').click(function(){
        $('html, body').animate({scrollTop: 0 }, 600);
        return false;
    });
});

$(function() {
    $('input[type="text"] + button.date-clear').on('click', function(){
        $(this).prevAll('.flatpickr-input').each(function() { this._flatpickr.clear(); });
    });
});

function shouldShowAgainAfterDismissal(dismissDateString, dismissDurationDays) {
    if (typeof dismissDateString === 'string') {
        var dismissDateMillis = parseInt(dismissDateString);
        if (typeof dismissDateMillis === 'number') {
            if (dismissDateMillis > Date.now()) {
                return true;
            }

            var expiryDate = new Date(dismissDateMillis);
            expiryDate.setDate(expiryDate.getDate() + dismissDurationDays);
            expiryDate.setHours(0, 0, 0, 0); // Expire at midnight.
            return Date.now() > expiryDate.getTime();
        }
    }
    return true;
}

/**
 * Outdated browser warning banner.
 */
$(function () {
    $('.supported-browsers-button').on('click', function () {
        $i.dialog({
            dialogSelector: '#supported-browsers-dialog'
        });
    });

    $('.browser-warning-dismiss-button').on('click', function () {
        localStorage.setItem('browserWarningDismissDate', Date.now());
        $('.browser-warning-banner').hide();
    });
});

function showBrowserWarning() {
    var dismissDateString = localStorage.getItem('browserWarningDismissDate');
    var showBanner = shouldShowAgainAfterDismissal(dismissDateString, 30);
    $('.browser-warning-banner').toggle(showBanner);

    if (showBanner) {
        localStorage.removeItem('browserWarningDismissDate');
    }
}

/**
 * Try new look panel.
 */
 $(function () {
    $('.try-new-look-hide-button').on('click', function () {
        localStorage.setItem('tryNewLookDismissDate', Date.now());
        $('.try-new-look-card').hide();
    });
})

function showTryNewLookPanel() {
    var dismissDateString = localStorage.getItem('tryNewLookDismissDate');
    var showPanel = shouldShowAgainAfterDismissal(dismissDateString, 7);
    $('.try-new-look-card').toggle(showPanel);

    if (showPanel) {
        localStorage.removeItem('tryNewLookDismissDate');
    }
}

// Add a header to identify AJAX requests to prevent redirects intended for pages.
(function(xhr){
    var open = xhr.open, send = xhr.send, sameOriginRequests = new Set();

    xhr.open = function(method, url){
        if (url.length > 0 && (url.charAt(0) === '/' || url.indexOf(window.location.origin) === 0)) {
            sameOriginRequests.add(this);
        }
        open.apply(this, arguments);
    };

    xhr.send = function(data) {
        if (sameOriginRequests.has(this)) {
            this.setRequestHeader('X-ITIS-AJAX', 'true');
            sameOriginRequests.delete(this);
        }
        send.apply(this, arguments);
    };
})(XMLHttpRequest.prototype);
